<template>
  <div>
    <custom-actions title="发票管理">
      <template #header> </template>
      <el-form inline ref="searchForm" class="global-form-label-width">
        <el-form-item prop="invoiceState" label="审核状态">
          <el-select
            v-model="searchForm.invoiceState"
            clearable
            filterable
            placeholder="请选择审核状态"
          >
            <el-option
              v-for="([key, value], index) of stateList"
              :value="key"
              :label="value"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSearch">查询</el-button>
          <el-button @click="resetForm">重置</el-button>
        </el-form-item>
      </el-form>
    </custom-actions>

    <el-card class="mt10" shadow="never">
      <el-table size="mini" stripe border v-loading="loading" :data="tableData">
        <el-table-column
          min-width="120"
          show-overflow-tooltip
          label="用户姓名"
          prop="userName"
        ></el-table-column>
        <el-table-column
          min-width="120"
          show-overflow-tooltip
          label="发票抬头"
          prop="invoiceHeader"
        ></el-table-column>
        <el-table-column
          min-width="120"
          show-overflow-tooltip
          label="发票金额(元)"
          prop="invoicePrice"
        ></el-table-column>
        <el-table-column
          min-width="120"
          show-overflow-tooltip
          label="审核状态"
          prop="invoiceState"
        >
          <template v-slot="{ row }">
            <el-tag type="primary" v-if="row.invoiceState == 1">
              {{ stateList.get("1") || "" }}
            </el-tag>
            <el-tag type="success" v-if="row.invoiceState == 2">
              {{ stateList.get("2") || "" }}
            </el-tag>
            <el-tag type="danger" v-if="row.invoiceState == 3">
              {{ stateList.get("3") || "" }}
            </el-tag>
          </template>
        </el-table-column>

        <el-table-column
          min-width="120"
          show-overflow-tooltip
          label="创建时间"
          prop="ctime"
        ></el-table-column>

        <el-table-column fixed="right" label="操作" width="100">
          <template v-slot="{ row }">
            <!-- <el-button type="text" @click='onExamine(row)' v-if="row.invoiceState == 1">审批</el-button> -->
            <el-button
              type="text"
              @click="
                $router.push('/invoiceManage/detail?invoiceId=' + row.invoiceId)
              "
              >详情</el-button
            >
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        :current-page.sync="page"
        background
        layout="total, prev, pager, next"
        :total="total"
        @current-change="loadData"
      >
      </el-pagination>
    </el-card>
    <!-- <ExamineDialog
      :invoiceId="invoiceId"
      :showDialog="showDialog"
      @closeDlg='showDialog=false'
      @successSave='loadData'
      :currentRow='currentRow'
      v-if="showDialog"
    ></ExamineDialog> -->
  </div>
</template>

<script>
import { stateList } from '@/utils/dict.js'
import keepAlive from '@/mixins/keepAlive'
// import ExamineDialog from '@/views/invoiceManage/examineDialog.vue'
export default {
  name: 'InvoiceManage',
  // components: { ExamineDialog },
  mixins: [keepAlive],
  data () {
    return {
      showDialog: false,
      invoiceId: '',
      page: 1,
      total: 0,
      tableData: [],

      loading: false,
      searchForm: {
        invoiceState: ''
      },
      stateList: stateList,
      currentRow: {}
    }
  },
  computed: {
    userInfo () {
      return this.$store.state.user
    }

  },

  created () {
    this.loadData()
  },
  methods: {
    // onExamine (item) {
    //   this.invoiceId = item.invoiceId
    //   this.currentRow = item
    //   this.showDialog = true
    // },
    loadData () {
      this.loading = true

      this.$axios.get(this.$apis.invoiceManage.selectYgInvoiceByList, {
        params: {
          page: this.page,
          size: 10,
          ...this.searchForm

        }
      }).then(res => {
        this.tableData = res.list
        this.total = res.total
      }).finally(() => {
        this.loading = false
      })
    },

    onSearch () {
      this.page = 1
      this.loadData()
    },
    resetForm () {
      this.time = []
      this.$refs.searchForm.resetFields()
      this.searchForm = {
        invoiceState: ''
      }
      this.onSearch()
    },
    deleteRow (inventoryId) {
      this.$confirm('确认删除该记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post(this.$apis.recordManage.deleteYgInventory, {
          inventoryId
        }).then(() => {
          this.loadData()
        })
      })
    }
  }
}
</script>

<style scoped lang='scss'></style>
